<template>
    <div v-if="this.$store.state.isMobile" v-show="this.$store.state.tarBarShow">
        <tab-bar>
            <tab-bar-item link="/HomeMobile">
                <img slot="icon" src="./img/colorLogo.svg">
                <img slot="active-icon" src="./img/colorLogo_active.svg">
                <div slot="text">首页</div>
            </tab-bar-item>
            <tab-bar-item link="/WordMobile">
                <img slot="icon" src="./img/word.svg">
                <img slot="active-icon" src="./img/word_active.svg">
                <div slot="text">单词</div>
            </tab-bar-item>
            <tab-bar-item link="/NoteMobile">
                <img slot="icon" src="./img/note.svg">
                <img slot="active-icon" src="./img/note_active.svg">
                <div slot="text">笔记</div>
            </tab-bar-item>
            <tab-bar-item link="LoadMobile">
                <img slot="icon" src="./img/book.svg">
                <img slot="active-icon" src="./img/book_active.svg">
                <div slot="text">收藏</div>
            </tab-bar-item>
        </tab-bar>
    </div>
</template>

<script>
    import TabBarItem from "./childComps/TabBarItem";
    import TabBar from "./childComps/TabBar";
    export default {
        name: "TabbarMobile",
        components: {TabBar, TabBarItem}
    }
</script>

<style scoped>

</style>